import { randomString, base64ToFile } from "@/utils/common"
import { uploadToOss } from "@/utils/uploadFile"

function upload(file) {
  let fileName = file.lastModified + "_" + randomString(8) + "_" + file.name
  let uploadPath = "print-template/" + fileName
  return uploadToOss(file, uploadPath)
    .then(ossRes => {
      return { result: true, msg: "", url: ossRes.url }
    })
    .catch(err => {
      console.log(err)
      return { result: false, msg: file.name + " 上传失败, 请重新上传！" }
    })
}

export function tinyImagesUpload(blobInfo, success, failure) {
  // const img = "data:image/jpeg;base64," + blobInfo.base64()
  let file = blobInfo.blob()
  if (!(file instanceof File)) {
    // 粘贴获取的图片不是File类型（也不是Blob），将base64转成File
    file = base64ToFile(blobInfo.base64(), file.name || "image.png", file.type, file.lastModified)
  }
  return upload(file)
    .then(res => {
      if (res.result) {
        success(res.url)
      } else {
        failure(res.msg)
      }
    })
    .catch(err => {
      console.log(err)
      failure("上传失败,请重新上传！")
    })
}
